const modalPlayer = document.querySelector('.js-modal-player');
if (modalPlayer) {
    import('../scripts/modalPlayer').then((module) => {
        module;
    });
}
